import React from 'react';
import { UI_TEXT } from '../constants';

interface LoadingSpinnerProps {
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = UI_TEXT.LOADING
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl p-8 shadow-2xl text-center max-w-md">
        <div className="text-6xl mb-4 animate-bounce">🎮</div>
        <h2 className="text-xl font-bold text-gray-800 mb-4">Getting Ready!</h2>
        <p className="text-gray-600 mb-6">{message}</p>
        <div className="relative w-16 h-16 mx-auto mb-4">
          <div className="absolute inset-0 border-4 border-blue-200 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-blue-500 rounded-full border-t-transparent animate-spin"></div>
        </div>
      </div>
    </div>
  );
};

export { LoadingSpinner };